import { useMemo } from "react";
import dayjs from "dayjs";
import { getValForKey } from "../utils/uniqueTv";

export function useUniqueTvSeries({ uniqueTvData, startDateInput, endDateInput }) {
  return useMemo(() => {
    const u = uniqueTvData?.data ?? uniqueTvData;
    if (!u || !startDateInput || !endDateInput) return [];

    const start = dayjs(startDateInput, "YYYY-MM-DD");
    const end = dayjs(endDateInput, "YYYY-MM-DD");
    if (!start.isValid() || !end.isValid() || start.isAfter(end)) return [];

    const out = [];
    let cursor = start.clone();

    while (!cursor.isAfter(end, "day")) {
      const ddKey = cursor.format("DD-MM-YYYY");

      out.push({
        label: ddKey,
        value: Number(getValForKey(u, ddKey)) || 0,
      });

      cursor = cursor.add(1, "day");
    }

    return out;
  }, [uniqueTvData, startDateInput, endDateInput]);
}
